
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as faqjm1nt3hFdDsJKrXJpBmTTG1l5GiXqvbIzD5vAIRDk9wMeta } from "/codebuild/output/src3533407447/src/src/pages/faq.vue?macro=true";
import { default as menuoCOG0dhgYsIooD11pWf9v_45mCeGr2Ll9NDd3CYUY2rAoMeta } from "/codebuild/output/src3533407447/src/src/pages/menu.vue?macro=true";
import { default as indexkU0dmodU6tNH_45YQ7IzRnhnO0B94sjPm8H_45mEZNwLpzkMeta } from "/codebuild/output/src3533407447/src/src/pages/index.vue?macro=true";
import { default as contactKFqDH0y8gydRwxxSNz5ZMiD930jrjs7QB1uxAmSF_45rAMeta } from "/codebuild/output/src3533407447/src/src/pages/contact.vue?macro=true";
import { default as tutorialpZSrWTDdUF3hPdulYIlzUeQog5u4BsMov275u3pw8T0Meta } from "/codebuild/output/src3533407447/src/src/pages/tutorial.vue?macro=true";
import { default as agreementqyLvPW4JXzy6mPJAzRuujc1j33xbJVLxJ0vxdVFnQGgMeta } from "/codebuild/output/src3533407447/src/src/pages/agreement.vue?macro=true";
import { default as about_45passSVWYUIN_kZxwKoYaT1w1lNawOXuHfMRfsCv9GQXV6FUMeta } from "/codebuild/output/src3533407447/src/src/pages/about-pass.vue?macro=true";
import { default as indexkoPJtvj1My1pN9__45V_45Dd6OkMvCn_jS9Uq2PtaooDpFUMeta } from "/codebuild/output/src3533407447/src/src/pages/card/index.vue?macro=true";
import { default as _91id_93yuUVQN_MTvj5_at6lo7wXBBVpSiqIjZW_bQFMvxUdJ4Meta } from "/codebuild/output/src3533407447/src/src/pages/coupon/[id].vue?macro=true";
import { default as maintenanceYuioLzmgpldSRJWOYeP6T4jLAANZZXE8DCjMtD4zbQEMeta } from "/codebuild/output/src3533407447/src/src/pages/maintenance.vue?macro=true";
import { default as _91id_93_45n6bJ6NttYh0gz3O3CM0nQvGoY9eJ_45rM6rBS61jkJPIMeta } from "/codebuild/output/src3533407447/src/src/pages/notice/[id].vue?macro=true";
import { default as indexif3rUiuUXcZ1uROUa7vHrPgDU0cW5Zf_hDHg8mXFMhsMeta } from "/codebuild/output/src3533407447/src/src/pages/coupon/index.vue?macro=true";
import { default as indexJFNrAzDcTE3bJiSrtusqfT3B_45eHNShPJjppw1uDGVYgMeta } from "/codebuild/output/src3533407447/src/src/pages/mypage/index.vue?macro=true";
import { default as indexZzmc9F19ggkke9dGFJ5FDxC2TZGJTG_ZAhnESfTwJDkMeta } from "/codebuild/output/src3533407447/src/src/pages/notice/index.vue?macro=true";
import { default as _91id_93fmVHRv7m9dAcmGCDtCDoLYN9NflK8Y4L9hyvTZdey4cMeta } from "/codebuild/output/src3533407447/src/src/pages/parking/[id].vue?macro=true";
import { default as indexEB_45zl_FzUjhcVv6dHKwMxQZyHqMZkseYbrJqK1iq_QkMeta } from "/codebuild/output/src3533407447/src/src/pages/history/index.vue?macro=true";
import { default as indexeSegZvAC1FvPN_45hNHnwPDjAh_M2D4rKz6xDKnY3J864Meta } from "/codebuild/output/src3533407447/src/src/pages/monthly/index.vue?macro=true";
import { default as index1cKd6udXlyBOyBvVQNm4Ec9pygZaV0Ym_OXiJ0b0TEgMeta } from "/codebuild/output/src3533407447/src/src/pages/sign-in/index.vue?macro=true";
import { default as indexAJJOpzNpcThgxd3Re7qjUbBGM95LiUgYKOGUqTw1aCQMeta } from "/codebuild/output/src3533407447/src/src/pages/sign-up/index.vue?macro=true";
import { default as about_45yumenavi5a_45NtzXg_45mkOJIAiwXDdL68ldpJlYlo6HOZ_45nNM124MMeta } from "/codebuild/output/src3533407447/src/src/pages/about-yumenavi.vue?macro=true";
import { default as editLukkCtGBN0L4tpnYXcKMrdP6qXa8O0PZW3ONptEwW6oMeta } from "/codebuild/output/src3533407447/src/src/pages/card/[id]/edit.vue?macro=true";
import { default as pass_45agreementCqSDjt8RI_45oATqbBbR_d1FBqE0Jq0wo0h3IYdUAazgAMeta } from "/codebuild/output/src3533407447/src/src/pages/pass-agreement.vue?macro=true";
import { default as indexfGjGvyGxjy1TgzYrunHCDSzPK1Eh5JnHtL9Wom44cz4Meta } from "/codebuild/output/src3533407447/src/src/pages/card/[id]/index.vue?macro=true";
import { default as confirm_453ddyY1ALS4fHW68XrxzJ6XvwTMKoPkOmauJ6WjON9OqCkMeta } from "/codebuild/output/src3533407447/src/src/pages/card/confirm-3d.vue?macro=true";
import { default as confirmsipJl2O_C_rK7tCWCZ8Uxw3PjgaHvErOlIRDODi_kVYMeta } from "/codebuild/output/src3533407447/src/src/pages/card/[id]/confirm.vue?macro=true";
import { default as index0Sb3jtAUrnU3vSniAHlP5Xu0bgAO8ZVSVbpHkCp7VwgMeta } from "/codebuild/output/src3533407447/src/src/pages/card/create/index.vue?macro=true";
import { default as index6ttvoDGJwpU5RwkmesEUPcFkdQzv_45UuoxPLFun8PTHIMeta } from "/codebuild/output/src3533407447/src/src/pages/mypage/pass/index.vue?macro=true";
import { default as confirmmQRcn9LbrMnT99j5vMxoayEi8BiT3nhe_45SpQBz8wEMQMeta } from "/codebuild/output/src3533407447/src/src/pages/membership/confirm.vue?macro=true";
import { default as confirm2JSaOY6nFhMC2ngxqJQzF7gYmk8I8d8rRkD8JYUp_q4Meta } from "/codebuild/output/src3533407447/src/src/pages/card/create/confirm.vue?macro=true";
import { default as completeaKpEtIW5mmgCaft16W7Pf2q7m7cBm989hBv1lg5Pc94Meta } from "/codebuild/output/src3533407447/src/src/pages/membership/complete.vue?macro=true";
import { default as registerTWzHF_45nslbVyW10mvm5cxgqdlVgzvjIevg4dmQbb3SkMeta } from "/codebuild/output/src3533407447/src/src/pages/membership/register.vue?macro=true";
import { default as _91id_935_45pT4CNlXspSx8wotw4m6Hxx6f8PKw0zQLUkmWateUgMeta } from "/codebuild/output/src3533407447/src/src/pages/monthly/notice/[id].vue?macro=true";
import { default as confirmLa3Mdx1lpTPR4OtOQh_457IXeHHVob3DNGUw_xg3ZiClEMeta } from "/codebuild/output/src3533407447/src/src/pages/contact-form/confirm.vue?macro=true";
import { default as _91id_93vjOlnm2G0dt2H5P7YyD65Z0LsYlqXD6DkKNax77rT5EMeta } from "/codebuild/output/src3533407447/src/src/pages/history/receipt/[id].vue?macro=true";
import { default as indexdsrTPNTJ4MKDcN3x_dvIdBdmZ8xSpvfrpw_45yIcOKoF0Meta } from "/codebuild/output/src3533407447/src/src/pages/monthly/notice/index.vue?macro=true";
import { default as confirm_45codefamSeEdgmbUUSij9ZMAunYKIbPPdvLNe22A_QtArTqEMeta } from "/codebuild/output/src3533407447/src/src/pages/sign-in/confirm-code.vue?macro=true";
import { default as confirm_45codeCM_45BdqMMh53tgftt0bunWsgZc_DFVgw0VZdW3GeTOVcMeta } from "/codebuild/output/src3533407447/src/src/pages/sign-up/confirm-code.vue?macro=true";
import { default as completeXj4e6K68cOYUP6VVHDYFEw1CxAUmzw1B_gPPttaOanwMeta } from "/codebuild/output/src3533407447/src/src/pages/contact-form/complete.vue?macro=true";
import { default as register4L75qfGIQoCsJQNn_rOmtdfggaicFc37FK42XJ1sbTsMeta } from "/codebuild/output/src3533407447/src/src/pages/contact-form/register.vue?macro=true";
import { default as completeOEaR_45jOq4j0d_g4G3hIkiCjr4z4oBninfCbrgAcl64AMeta } from "/codebuild/output/src3533407447/src/src/pages/monthly/cancel/complete.vue?macro=true";
import { default as indexX2nlsVSvyMiNamlIZUTAOAV98frgq_45V3_45I3Xp57Jd80Meta } from "/codebuild/output/src3533407447/src/src/pages/mypage/membership/index.vue?macro=true";
import { default as confirmyxiR6jbGvZ93D2ynahTipB_45IVLpK2g5AUhiPOQMukg8Meta } from "/codebuild/output/src3533407447/src/src/pages/mypage/sign-out/confirm.vue?macro=true";
import { default as complete8EldKBCbjID72HM6zHxrjLxf27MPiiDAqtRqn9gxOC8Meta } from "/codebuild/output/src3533407447/src/src/pages/reset-password/complete.vue?macro=true";
import { default as indexIL8SsuMDHajMWswA7PA2mHgmvBrgy6xgReBMDB62958Meta } from "/codebuild/output/src3533407447/src/src/pages/mypage/integration/index.vue?macro=true";
import { default as _91id_93kmu_45Iwp6Q87xvoh3ZTH_45n_454aBwsxzZ22uizrqPL6CIwMeta } from "/codebuild/output/src3533407447/src/src/pages/mypage/pass/receipt/[id].vue?macro=true";
import { default as completectPHlUoO_450359eVbupj4ZO8V3A779UteUtwu3fhFQZsMeta } from "/codebuild/output/src3533407447/src/src/pages/mypage/sign-out/complete.vue?macro=true";
import { default as edit_45card_45aliasgB_6c3SniE0lZk0qA1xYJLIuj67Pth0r7TRkM_45j_45qXAMeta } from "/codebuild/output/src3533407447/src/src/pages/card/[id]/edit-card-alias.vue?macro=true";
import { default as sampleBWHpRW1kK2ZywmMrAbAejALFsKc4H998fJhJWmwtHVEMeta } from "/codebuild/output/src3533407447/src/src/pages/mypage/integration/sample.vue?macro=true";
import { default as send_45emailKlbhxCi3alnQIWy2Fghm_9o7KCUvbYOMA1SeB7jcbdQMeta } from "/codebuild/output/src3533407447/src/src/pages/reset-password/send-email.vue?macro=true";
import { default as confirm13BYd63DA1dcCWHirx0w0khgYNRcPw_MCtogV2VGDo0Meta } from "/codebuild/output/src3533407447/src/src/pages/mypage/unsubscribe/confirm.vue?macro=true";
import { default as consentyOpc45Vyo3rP8fdB2NoM76QCTQnwg2twFr_urpfr6cAMeta } from "/codebuild/output/src3533407447/src/src/pages/mypage/unsubscribe/consent.vue?macro=true";
import { default as confirmbPU_455F8hojSZ_Wv5HxX_uc6R3YQe8L_45flDs_45llVqT8QMeta } from "/codebuild/output/src3533407447/src/src/pages/membership/yumenavi/confirm.vue?macro=true";
import { default as duedate7j0wvaLViH1uSsIai9raMxhTf96hAePABSpxCVwWSycMeta } from "/codebuild/output/src3533407447/src/src/pages/monthly/application/duedate.vue?macro=true";
import { default as completeF6Lb2Gqct_45qCN8uCg2y3zs_45ie4nmoMFSDezMTq3vO2QMeta } from "/codebuild/output/src3533407447/src/src/pages/mypage/unsubscribe/complete.vue?macro=true";
import { default as confirm_45code1tTfqlVnMx03s6AfA3eeq_455J4jlKPfoQALIEHAJRGU0Meta } from "/codebuild/output/src3533407447/src/src/pages/reset-password/confirm-code.vue?macro=true";
import { default as new_45passwordAXRvoItdeB9BVhuhbfHKso5xlhNh24bXoOCzMC_453zjoMeta } from "/codebuild/output/src3533407447/src/src/pages/reset-password/new-password.vue?macro=true";
import { default as confirm_45card_45aliasHfBESMxy3Us1F_ekjgBAApjQ4vqhvFkfvUj7GbNxLgEMeta } from "/codebuild/output/src3533407447/src/src/pages/card/[id]/confirm-card-alias.vue?macro=true";
import { default as registeruARk4VV_456yGouAAXYYWoZzGry7Dee1hbaYO0KXQWRlMMeta } from "/codebuild/output/src3533407447/src/src/pages/membership/yumenavi/register.vue?macro=true";
import { default as confirm_45codex4kAB9D8bbgcIDqKDzpk7iysmCwR2Nz9wpuLeZTCgRgMeta } from "/codebuild/output/src3533407447/src/src/pages/membership/yumenavi/confirm-code.vue?macro=true";
import { default as indexe3dRn2lSl3iHjvcpm3q4xPPlEvANehEzsYcxgASYk0YMeta } from "/codebuild/output/src3533407447/src/src/pages/mypage/membership/email-edit/index.vue?macro=true";
import { default as indexJdTCj3E5kdz2uWPY1Ak4_Sr7qaloVDpGVffq9sevuvoMeta } from "/codebuild/output/src3533407447/src/src/pages/monthly/close/[applicationId]/index.vue?macro=true";
import { default as index3blffiv_45HARWjcGCDo3_45zc4wX_BARkx5_45So6efbNMz4Meta } from "/codebuild/output/src3533407447/src/src/pages/mypage/membership/others-edit/index.vue?macro=true";
import { default as indexGF7jj5Yc2BAmhY7ZDXZfC9NiQqiEDSwKnaj_sq_45TEdsMeta } from "/codebuild/output/src3533407447/src/src/pages/monthly/cancel/[applicationId]/index.vue?macro=true";
import { default as update_45_45hMC64_45_gg9YkFMEbDObGeFnD1Z9XWm7Z86zxWwOJAMeta } from "/codebuild/output/src3533407447/src/src/pages/mypage/membership/others-edit/update.vue?macro=true";
import { default as completekzcG1fcjFNntNrs_452xH6S9PU0TwARghH81d3mxhtZ6sMeta } from "/codebuild/output/src3533407447/src/src/pages/mypage/membership/email-edit/complete.vue?macro=true";
import { default as confirmUOARBV09wDSzCVlLFEwIXg1O95P5ZTqzQvS3a4IwinoMeta } from "/codebuild/output/src3533407447/src/src/pages/mypage/membership/others-edit/confirm.vue?macro=true";
import { default as indexOpJphxoQbYTSO3bT95TbU7PUpm8eYdabDxrXseiAK7sMeta } from "/codebuild/output/src3533407447/src/src/pages/monthly/payments/[applicationId]/index.vue?macro=true";
import { default as complete_45XtWlryiE0v1q39TZaVinJvVFkDkk9Rn_45RFZoc1Io7UMeta } from "/codebuild/output/src3533407447/src/src/pages/mypage/membership/others-edit/complete.vue?macro=true";
import { default as updateKUOee9HtT6n1IvLgvXIElxwk4J_yCYgrDXO5R_45jQJ1UMeta } from "/codebuild/output/src3533407447/src/src/pages/mypage/membership/password-edit/update.vue?macro=true";
import { default as indexgBpyE_45Y1p93HAnjXfqKs12123fvzp5LpxxofzNuHTP0Meta } from "/codebuild/output/src3533407447/src/src/pages/monthly/applicant/[applicationId]/index.vue?macro=true";
import { default as indexHZ18V_45Jl_W1oH05cDBfXioVzZmyYD4q_45IsH7_fRtKIEMeta } from "/codebuild/output/src3533407447/src/src/pages/monthly/preapplication/[parkingId]/index.vue?macro=true";
import { default as completeDQuZc4nA5EnNTkL2ceUXf_ksG_RoasdOEvjl110Dg0cMeta } from "/codebuild/output/src3533407447/src/src/pages/mypage/membership/password-edit/complete.vue?macro=true";
import { default as indexmipdzk8gUftmfhE1WZ_45oa_4535vUSvi3eWEflhtl_45djTAMeta } from "/codebuild/output/src3533407447/src/src/pages/monthly/application/[applicationId]/index.vue?macro=true";
import { default as confirm_45code4osFw2lBEwVLut_45dws5EN_hPSlYubJgYSfTZZ_45s8ivkMeta } from "/codebuild/output/src3533407447/src/src/pages/mypage/membership/email-edit/confirm-code.vue?macro=true";
import { default as indexON3jRrLL_kEEfSDXp2Y4NQGY_0lOCyTXbUSFguCQz0QMeta } from "/codebuild/output/src3533407447/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue?macro=true";
import { default as indexGsN1exp1pIzGR9C7xJ8b7ch9W3jHc0sPEsZYtiRX64AMeta } from "/codebuild/output/src3533407447/src/src/pages/monthly/payments/method/[applicationId]/index.vue?macro=true";
import { default as indexckMODRdjhTL3FenrDmq_phxZ65mLQ7nechQdnGIYtoQMeta } from "/codebuild/output/src3533407447/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue?macro=true";
import { default as updatev3klFuEmJ9V4GxgngH1nFa_45p_45bEO5ZYVZGluUJCzJl4Meta } from "/codebuild/output/src3533407447/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue?macro=true";
import { default as confirm_MBcNwbOlpdK_yiBJYTKmxq10EKr3u1pLNDIOSb7hIQMeta } from "/codebuild/output/src3533407447/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue?macro=true";
export default [
  {
    name: "faq",
    path: "/faq",
    component: () => import("/codebuild/output/src3533407447/src/src/pages/faq.vue")
  },
  {
    name: "menu",
    path: "/menu",
    meta: menuoCOG0dhgYsIooD11pWf9v_45mCeGr2Ll9NDd3CYUY2rAoMeta || {},
    component: () => import("/codebuild/output/src3533407447/src/src/pages/menu.vue")
  },
  {
    name: "index",
    path: "/",
    meta: indexkU0dmodU6tNH_45YQ7IzRnhnO0B94sjPm8H_45mEZNwLpzkMeta || {},
    component: () => import("/codebuild/output/src3533407447/src/src/pages/index.vue")
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("/codebuild/output/src3533407447/src/src/pages/contact.vue")
  },
  {
    name: "tutorial",
    path: "/tutorial",
    component: () => import("/codebuild/output/src3533407447/src/src/pages/tutorial.vue")
  },
  {
    name: "agreement",
    path: "/agreement",
    component: () => import("/codebuild/output/src3533407447/src/src/pages/agreement.vue")
  },
  {
    name: "about-pass",
    path: "/about-pass",
    component: () => import("/codebuild/output/src3533407447/src/src/pages/about-pass.vue")
  },
  {
    name: "card",
    path: "/card",
    component: () => import("/codebuild/output/src3533407447/src/src/pages/card/index.vue")
  },
  {
    name: "coupon-id",
    path: "/coupon/:id()",
    component: () => import("/codebuild/output/src3533407447/src/src/pages/coupon/[id].vue")
  },
  {
    name: "maintenance",
    path: "/maintenance",
    component: () => import("/codebuild/output/src3533407447/src/src/pages/maintenance.vue")
  },
  {
    name: "notice-id",
    path: "/notice/:id()",
    component: () => import("/codebuild/output/src3533407447/src/src/pages/notice/[id].vue")
  },
  {
    name: "coupon",
    path: "/coupon",
    meta: { ...(indexif3rUiuUXcZ1uROUa7vHrPgDU0cW5Zf_hDHg8mXFMhsMeta || {}), ...{"middleware":["coupon-params"]} },
    component: () => import("/codebuild/output/src3533407447/src/src/pages/coupon/index.vue")
  },
  {
    name: "mypage",
    path: "/mypage",
    meta: {"middleware":"unsubscribe-store-control"},
    component: () => import("/codebuild/output/src3533407447/src/src/pages/mypage/index.vue")
  },
  {
    name: "notice",
    path: "/notice",
    meta: {"middleware":["notice-params"]},
    component: () => import("/codebuild/output/src3533407447/src/src/pages/notice/index.vue")
  },
  {
    name: "parking-id",
    path: "/parking/:id()",
    meta: {"middleware":["set-redirect-url","payment-step"]},
    component: () => import("/codebuild/output/src3533407447/src/src/pages/parking/[id].vue")
  },
  {
    name: "history",
    path: "/history",
    meta: { ...(indexEB_45zl_FzUjhcVv6dHKwMxQZyHqMZkseYbrJqK1iq_QkMeta || {}), ...{"middleware":["payment-params"]} },
    component: () => import("/codebuild/output/src3533407447/src/src/pages/history/index.vue")
  },
  {
    name: "monthly",
    path: "/monthly",
    component: () => import("/codebuild/output/src3533407447/src/src/pages/monthly/index.vue")
  },
  {
    name: "sign-in",
    path: "/sign-in",
    meta: index1cKd6udXlyBOyBvVQNm4Ec9pygZaV0Ym_OXiJ0b0TEgMeta || {},
    component: () => import("/codebuild/output/src3533407447/src/src/pages/sign-in/index.vue")
  },
  {
    name: "sign-up",
    path: "/sign-up",
    meta: indexAJJOpzNpcThgxd3Re7qjUbBGM95LiUgYKOGUqTw1aCQMeta || {},
    component: () => import("/codebuild/output/src3533407447/src/src/pages/sign-up/index.vue")
  },
  {
    name: "about-yumenavi",
    path: "/about-yumenavi",
    component: () => import("/codebuild/output/src3533407447/src/src/pages/about-yumenavi.vue")
  },
  {
    name: "card-id-edit",
    path: "/card/:id()/edit",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src3533407447/src/src/pages/card/[id]/edit.vue")
  },
  {
    name: "pass-agreement",
    path: "/pass-agreement",
    component: () => import("/codebuild/output/src3533407447/src/src/pages/pass-agreement.vue")
  },
  {
    name: "card-id",
    path: "/card/:id()",
    component: () => import("/codebuild/output/src3533407447/src/src/pages/card/[id]/index.vue")
  },
  {
    name: "card-confirm-3d",
    path: "/card/confirm-3d",
    component: () => import("/codebuild/output/src3533407447/src/src/pages/card/confirm-3d.vue")
  },
  {
    name: "card-id-confirm",
    path: "/card/:id()/confirm",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src3533407447/src/src/pages/card/[id]/confirm.vue")
  },
  {
    name: "card-create",
    path: "/card/create",
    meta: index0Sb3jtAUrnU3vSniAHlP5Xu0bgAO8ZVSVbpHkCp7VwgMeta || {},
    component: () => import("/codebuild/output/src3533407447/src/src/pages/card/create/index.vue")
  },
  {
    name: "mypage-pass",
    path: "/mypage/pass",
    meta: {"middleware":["pass-payment-params"]},
    component: () => import("/codebuild/output/src3533407447/src/src/pages/mypage/pass/index.vue")
  },
  {
    name: "membership-confirm",
    path: "/membership/confirm",
    meta: confirmmQRcn9LbrMnT99j5vMxoayEi8BiT3nhe_45SpQBz8wEMQMeta || {},
    component: () => import("/codebuild/output/src3533407447/src/src/pages/membership/confirm.vue")
  },
  {
    name: "card-create-confirm",
    path: "/card/create/confirm",
    meta: { ...(confirm2JSaOY6nFhMC2ngxqJQzF7gYmk8I8d8rRkD8JYUp_q4Meta || {}), ...{"middleware":["editing-card"]} },
    component: () => import("/codebuild/output/src3533407447/src/src/pages/card/create/confirm.vue")
  },
  {
    name: "membership-complete",
    path: "/membership/complete",
    meta: completeaKpEtIW5mmgCaft16W7Pf2q7m7cBm989hBv1lg5Pc94Meta || {},
    component: () => import("/codebuild/output/src3533407447/src/src/pages/membership/complete.vue")
  },
  {
    name: "membership-register",
    path: "/membership/register",
    meta: registerTWzHF_45nslbVyW10mvm5cxgqdlVgzvjIevg4dmQbb3SkMeta || {},
    component: () => import("/codebuild/output/src3533407447/src/src/pages/membership/register.vue")
  },
  {
    name: "monthly-notice-id",
    path: "/monthly/notice/:id()",
    component: () => import("/codebuild/output/src3533407447/src/src/pages/monthly/notice/[id].vue")
  },
  {
    name: "contact-form-confirm",
    path: "/contact-form/confirm",
    meta: confirmLa3Mdx1lpTPR4OtOQh_457IXeHHVob3DNGUw_xg3ZiClEMeta || {},
    component: () => import("/codebuild/output/src3533407447/src/src/pages/contact-form/confirm.vue")
  },
  {
    name: "history-receipt-id",
    path: "/history/receipt/:id()",
    component: () => import("/codebuild/output/src3533407447/src/src/pages/history/receipt/[id].vue")
  },
  {
    name: "monthly-notice",
    path: "/monthly/notice",
    component: () => import("/codebuild/output/src3533407447/src/src/pages/monthly/notice/index.vue")
  },
  {
    name: "sign-in-confirm-code",
    path: "/sign-in/confirm-code",
    meta: confirm_45codefamSeEdgmbUUSij9ZMAunYKIbPPdvLNe22A_QtArTqEMeta || {},
    component: () => import("/codebuild/output/src3533407447/src/src/pages/sign-in/confirm-code.vue")
  },
  {
    name: "sign-up-confirm-code",
    path: "/sign-up/confirm-code",
    meta: confirm_45codeCM_45BdqMMh53tgftt0bunWsgZc_DFVgw0VZdW3GeTOVcMeta || {},
    component: () => import("/codebuild/output/src3533407447/src/src/pages/sign-up/confirm-code.vue")
  },
  {
    name: "contact-form-complete",
    path: "/contact-form/complete",
    meta: completeXj4e6K68cOYUP6VVHDYFEw1CxAUmzw1B_gPPttaOanwMeta || {},
    component: () => import("/codebuild/output/src3533407447/src/src/pages/contact-form/complete.vue")
  },
  {
    name: "contact-form-register",
    path: "/contact-form/register",
    meta: register4L75qfGIQoCsJQNn_rOmtdfggaicFc37FK42XJ1sbTsMeta || {},
    component: () => import("/codebuild/output/src3533407447/src/src/pages/contact-form/register.vue")
  },
  {
    name: "monthly-cancel-complete",
    path: "/monthly/cancel/complete",
    component: () => import("/codebuild/output/src3533407447/src/src/pages/monthly/cancel/complete.vue")
  },
  {
    name: "mypage-membership",
    path: "/mypage/membership",
    component: () => import("/codebuild/output/src3533407447/src/src/pages/mypage/membership/index.vue")
  },
  {
    name: "mypage-sign-out-confirm",
    path: "/mypage/sign-out/confirm",
    meta: { ...(confirmyxiR6jbGvZ93D2ynahTipB_45IVLpK2g5AUhiPOQMukg8Meta || {}), ...{"middleware":"logout-control"} },
    component: () => import("/codebuild/output/src3533407447/src/src/pages/mypage/sign-out/confirm.vue")
  },
  {
    name: "reset-password-complete",
    path: "/reset-password/complete",
    meta: complete8EldKBCbjID72HM6zHxrjLxf27MPiiDAqtRqn9gxOC8Meta || {},
    component: () => import("/codebuild/output/src3533407447/src/src/pages/reset-password/complete.vue")
  },
  {
    name: "mypage-integration",
    path: "/mypage/integration",
    meta: { ...(indexIL8SsuMDHajMWswA7PA2mHgmvBrgy6xgReBMDB62958Meta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src3533407447/src/src/pages/mypage/integration/index.vue")
  },
  {
    name: "mypage-pass-receipt-id",
    path: "/mypage/pass/receipt/:id()",
    component: () => import("/codebuild/output/src3533407447/src/src/pages/mypage/pass/receipt/[id].vue")
  },
  {
    name: "mypage-sign-out-complete",
    path: "/mypage/sign-out/complete",
    meta: completectPHlUoO_450359eVbupj4ZO8V3A779UteUtwu3fhFQZsMeta || {},
    component: () => import("/codebuild/output/src3533407447/src/src/pages/mypage/sign-out/complete.vue")
  },
  {
    name: "card-id-edit-card-alias",
    path: "/card/:id()/edit-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src3533407447/src/src/pages/card/[id]/edit-card-alias.vue")
  },
  {
    name: "mypage-integration-sample",
    path: "/mypage/integration/sample",
    meta: { ...(sampleBWHpRW1kK2ZywmMrAbAejALFsKc4H998fJhJWmwtHVEMeta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src3533407447/src/src/pages/mypage/integration/sample.vue")
  },
  {
    name: "reset-password-send-email",
    path: "/reset-password/send-email",
    meta: send_45emailKlbhxCi3alnQIWy2Fghm_9o7KCUvbYOMA1SeB7jcbdQMeta || {},
    component: () => import("/codebuild/output/src3533407447/src/src/pages/reset-password/send-email.vue")
  },
  {
    name: "mypage-unsubscribe-confirm",
    path: "/mypage/unsubscribe/confirm",
    meta: { ...(confirm13BYd63DA1dcCWHirx0w0khgYNRcPw_MCtogV2VGDo0Meta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src3533407447/src/src/pages/mypage/unsubscribe/confirm.vue")
  },
  {
    name: "mypage-unsubscribe-consent",
    path: "/mypage/unsubscribe/consent",
    meta: { ...(consentyOpc45Vyo3rP8fdB2NoM76QCTQnwg2twFr_urpfr6cAMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src3533407447/src/src/pages/mypage/unsubscribe/consent.vue")
  },
  {
    name: "membership-yumenavi-confirm",
    path: "/membership/yumenavi/confirm",
    meta: confirmbPU_455F8hojSZ_Wv5HxX_uc6R3YQe8L_45flDs_45llVqT8QMeta || {},
    component: () => import("/codebuild/output/src3533407447/src/src/pages/membership/yumenavi/confirm.vue")
  },
  {
    name: "monthly-application-duedate",
    path: "/monthly/application/duedate",
    component: () => import("/codebuild/output/src3533407447/src/src/pages/monthly/application/duedate.vue")
  },
  {
    name: "mypage-unsubscribe-complete",
    path: "/mypage/unsubscribe/complete",
    meta: { ...(completeF6Lb2Gqct_45qCN8uCg2y3zs_45ie4nmoMFSDezMTq3vO2QMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src3533407447/src/src/pages/mypage/unsubscribe/complete.vue")
  },
  {
    name: "reset-password-confirm-code",
    path: "/reset-password/confirm-code",
    meta: confirm_45code1tTfqlVnMx03s6AfA3eeq_455J4jlKPfoQALIEHAJRGU0Meta || {},
    component: () => import("/codebuild/output/src3533407447/src/src/pages/reset-password/confirm-code.vue")
  },
  {
    name: "reset-password-new-password",
    path: "/reset-password/new-password",
    meta: new_45passwordAXRvoItdeB9BVhuhbfHKso5xlhNh24bXoOCzMC_453zjoMeta || {},
    component: () => import("/codebuild/output/src3533407447/src/src/pages/reset-password/new-password.vue")
  },
  {
    name: "card-id-confirm-card-alias",
    path: "/card/:id()/confirm-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src3533407447/src/src/pages/card/[id]/confirm-card-alias.vue")
  },
  {
    name: "membership-yumenavi-register",
    path: "/membership/yumenavi/register",
    meta: registeruARk4VV_456yGouAAXYYWoZzGry7Dee1hbaYO0KXQWRlMMeta || {},
    component: () => import("/codebuild/output/src3533407447/src/src/pages/membership/yumenavi/register.vue")
  },
  {
    name: "membership-yumenavi-confirm-code",
    path: "/membership/yumenavi/confirm-code",
    meta: confirm_45codex4kAB9D8bbgcIDqKDzpk7iysmCwR2Nz9wpuLeZTCgRgMeta || {},
    component: () => import("/codebuild/output/src3533407447/src/src/pages/membership/yumenavi/confirm-code.vue")
  },
  {
    name: "mypage-membership-email-edit",
    path: "/mypage/membership/email-edit",
    component: () => import("/codebuild/output/src3533407447/src/src/pages/mypage/membership/email-edit/index.vue")
  },
  {
    name: "monthly-close-applicationId",
    path: "/monthly/close/:applicationId()",
    component: () => import("/codebuild/output/src3533407447/src/src/pages/monthly/close/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit",
    path: "/mypage/membership/others-edit",
    component: () => import("/codebuild/output/src3533407447/src/src/pages/mypage/membership/others-edit/index.vue")
  },
  {
    name: "monthly-cancel-applicationId",
    path: "/monthly/cancel/:applicationId()",
    component: () => import("/codebuild/output/src3533407447/src/src/pages/monthly/cancel/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-update",
    path: "/mypage/membership/others-edit/update",
    component: () => import("/codebuild/output/src3533407447/src/src/pages/mypage/membership/others-edit/update.vue")
  },
  {
    name: "mypage-membership-email-edit-complete",
    path: "/mypage/membership/email-edit/complete",
    component: () => import("/codebuild/output/src3533407447/src/src/pages/mypage/membership/email-edit/complete.vue")
  },
  {
    name: "mypage-membership-others-edit-confirm",
    path: "/mypage/membership/others-edit/confirm",
    component: () => import("/codebuild/output/src3533407447/src/src/pages/mypage/membership/others-edit/confirm.vue")
  },
  {
    name: "monthly-payments-applicationId",
    path: "/monthly/payments/:applicationId()",
    component: () => import("/codebuild/output/src3533407447/src/src/pages/monthly/payments/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-complete",
    path: "/mypage/membership/others-edit/complete",
    component: () => import("/codebuild/output/src3533407447/src/src/pages/mypage/membership/others-edit/complete.vue")
  },
  {
    name: "mypage-membership-password-edit-update",
    path: "/mypage/membership/password-edit/update",
    component: () => import("/codebuild/output/src3533407447/src/src/pages/mypage/membership/password-edit/update.vue")
  },
  {
    name: "monthly-applicant-applicationId",
    path: "/monthly/applicant/:applicationId()",
    component: () => import("/codebuild/output/src3533407447/src/src/pages/monthly/applicant/[applicationId]/index.vue")
  },
  {
    name: "monthly-preapplication-parkingId",
    path: "/monthly/preapplication/:parkingId()",
    component: () => import("/codebuild/output/src3533407447/src/src/pages/monthly/preapplication/[parkingId]/index.vue")
  },
  {
    name: "mypage-membership-password-edit-complete",
    path: "/mypage/membership/password-edit/complete",
    component: () => import("/codebuild/output/src3533407447/src/src/pages/mypage/membership/password-edit/complete.vue")
  },
  {
    name: "monthly-application-applicationId",
    path: "/monthly/application/:applicationId()",
    component: () => import("/codebuild/output/src3533407447/src/src/pages/monthly/application/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-email-edit-confirm-code",
    path: "/mypage/membership/email-edit/confirm-code",
    component: () => import("/codebuild/output/src3533407447/src/src/pages/mypage/membership/email-edit/confirm-code.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi",
    path: "/mypage/membership/others-edit/yumenavi",
    component: () => import("/codebuild/output/src3533407447/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue")
  },
  {
    name: "monthly-payments-method-applicationId",
    path: "/monthly/payments/method/:applicationId()",
    component: () => import("/codebuild/output/src3533407447/src/src/pages/monthly/payments/method/[applicationId]/index.vue")
  },
  {
    name: "monthly-renewalcontract-applicationId",
    path: "/monthly/renewalcontract/:applicationId()",
    component: () => import("/codebuild/output/src3533407447/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-update",
    path: "/mypage/membership/others-edit/yumenavi/update",
    component: () => import("/codebuild/output/src3533407447/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-confirm",
    path: "/mypage/membership/others-edit/yumenavi/confirm",
    component: () => import("/codebuild/output/src3533407447/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue")
  }
]